module.exports = __webpack_public_path__ + "static/media/investpic2@2x.c0562ea8.png";